import { useLocalization } from 'hooks/useLocalization';

interface ActivityTypeTitleSmallProps {
	activityType: 'private' | 'group';
}

function ActivityTypeTitleSmall ({ activityType }: ActivityTypeTitleSmallProps) {
    const { getStr } = useLocalization();

	let colorHex;
	let title;
	
	switch (activityType) {
		case 'private':
			colorHex = '1c61ee';
			title = getStr('Private');
			break;

		case 'group':
			colorHex = '349d2a';
			title = getStr('Group');
			break;
	}

	return (
		<>
			<div style={{ fontSize: '0.8em', color: `#${colorHex}` }}>
				{title}
			</div>
		</>
	);
}

export default ActivityTypeTitleSmall;